import { FC, useEffect, useState } from "react"

import './index.css'

import { useLocation, useNavigate, useParams } from "react-router-dom"
import { ChrevonLeftIcon } from "../../components/MenuIcons/ChevrotLeft"
import { Outlet, Route, Routes } from 'react-router-dom'
import { IndexPerfil } from "./index"
import { PerfilInfo } from "./info/info"
import { ResetSenha } from "./resetPassword/reset"
import { Privacy } from "./privacy/privacy"
import { Delete } from "./delete/delete"
import { Footer } from "../../components/Footer/footer"
import { AddressesIndex } from "./addresses/addressesIndex"
import { UpdateAddress } from "./addresses/createUpdate/UpdateAddress"
import { CreateAddress } from "./addresses/createUpdate/CreateAddress"


type Options = {
    icon: string,
    title: string,
    subtitle: string,
    route: string,

}

type Route = {
    name: string,
    options: Options[]
}



const PerfilLayout: FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {pluginspace_id,id_address} = useParams()


    const toNavigate = () => {

        const path = location.pathname.split('/')
        const pathLength = path.length > 0 ? path.length - 1 : 0

        if(path[pathLength] == 'addresses' || path[pathLength] == 'privacy' || path[pathLength] == 'info' || path[pathLength] == 'new_password' ){
            navigate(`/${pluginspace_id}/profile`)
        }else if(path[pathLength] == id_address || path[pathLength] =='create'){
            navigate(`/${pluginspace_id}/profile/addresses`)
        }else if( path[pathLength] =='delete'){
            navigate(`/${pluginspace_id}/profile/privacy`)
        }else{
            navigate(`/${pluginspace_id}/category`)
        }

       
    }

    return (
        <div className="perfil">
            <div className="Perfilcontent">
                <div className="back">
                    <ChrevonLeftIcon action={() => toNavigate()} />
                </div>


                <Outlet />


                <Footer />
            </div >
        </div >
    )
}


const PerfilPage = () => (
    <Routes>
        <Route element={<PerfilLayout />}>
            <Route path='profile' element={<IndexPerfil />} />
            {/*<Route path='esqueci-senha' element={<ForgotPassword />} /> */}
            <Route path='info' element={<PerfilInfo />} />
            <Route path='new_password' element={<ResetSenha />} />
            <Route path='privacy' element={<Privacy />} />
            <Route path='privacy/delete' element={<Delete />} />
            <Route path='addresses' element={<AddressesIndex />} />
            <Route path='addresses/create' element={<CreateAddress />} />
            <Route path='addresses/:id_address' element={<UpdateAddress />} />
            <Route index element={<IndexPerfil />} />
        </Route>
    </Routes>
)

export { PerfilPage }